import { PureComponent } from 'react'

import withErrorBoundary from '~/core/withErrorBoundary'
import BrokenComponent from '~/components/BrokenComponent'

class FixedLayoutContentWrapper extends PureComponent {
    render() {
        return typeof this.props.content === 'function'
            ? this.props.content()
            : this.props.content
    }
}

export default withErrorBoundary({
    renderError: <BrokenComponent block />,
})(FixedLayoutContentWrapper)
